import { render } from "./ShopPosList.vue?vue&type=template&id=0f4fc659&scoped=true"
import script from "./ShopPosList.vue?vue&type=script&lang=js"
export * from "./ShopPosList.vue?vue&type=script&lang=js"

import "./ShopPosList.vue?vue&type=style&index=0&id=0f4fc659&lang=scss&scoped=true"
import "./ShopPosList.vue?vue&type=style&index=1&id=0f4fc659&lang=css"

import exportComponent from "/Users/ilss0902/PorjectCenter/Cloudmobile/雲端POS_V2/code/pos_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f4fc659"]])

export default __exports__